/* ==========================================================================
   NINJA FACE — Cagoules (sections Shopify)
   Un seul fichier pour toutes les sections. Chaque section porte
   data-cg-section="<nom>" ; on l'initialise une fois, et on la ré-initialise
   quand l'éditeur de thème la recharge (shopify:section:load).
   ========================================================================== */
(function () {
  'use strict';

  /* Le snippet d'assets est rendu par chaque section : le script peut être
     inclus plusieurs fois. On ne l'exécute qu'une fois. */
  if (window.CagoulesInit) return;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ======================================================================
     PANIER — Ajax Shopify, puis on prévient le thème
     ====================================================================== */
  function cartAdd(root, id, qty) {
    var addUrl  = root.dataset.addUrl  || '/cart/add.js';
    var cartUrl = root.dataset.cartUrl || '/cart.js';

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'add failed'); });
      return r.json();
    }).then(function () {
      return fetch(cartUrl, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      /* Compteurs génériques que nos sections affichent. */
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count ? '' : 'none';
      });
      /* Événements attendus par les thèmes Maestrooo (Prestige, Impact…) et
         par la plupart des tiroirs panier : ils rafraîchissent et s'ouvrent. */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cagoule:cart-added', { detail: { cart: cart, id: id, qty: qty } }));
      return cart;
    });
  }

  function afterAdd(root, mode) {
    /* Un tiroir panier est présent (en-tête) : il s'est déjà ouvert via
       l'événement cagoule:cart-added ; on ne quitte pas la page. */
    if (mode === 'cart' && document.querySelector('[data-cart-drawer]')) return;
    if (mode === 'cart')     location.href = root.dataset.cartPage || '/cart';
    if (mode === 'checkout') location.href = root.dataset.checkoutPage || '/checkout';
  }

  function flash(btn, text, cls) {
    var old = btn.textContent;
    btn.textContent = text;
    btn.classList.add(cls || 'is-done');
    setTimeout(function () {
      btn.textContent = old;
      btn.classList.remove(cls || 'is-done');
    }, 1600);
  }

  /* ======================================================================
     HERO — fond fixe + dérive parallax
     ====================================================================== */
  function initHero(root) {
    /* CTA : descente fluide vers la grille produits si elle est sur la page */
    var cta = $('[data-cg-cta]', root);
    if (cta) {
      cta.addEventListener('click', function (e) {
        var href = cta.getAttribute('href') || '';
        var target = null;
        if (cta.dataset.scrollTo === 'products' || href.indexOf('#') === 0) {
          target = (href.indexOf('#') === 0 && href.length > 1 && document.querySelector(href)) ||
                   document.querySelector('[data-cg-section="cagoules-grid"], [data-cg-section="collection-grid"]') ||
                   document.getElementById('cg-produits');
        }
        if (!target) return;                 /* lien externe : comportement normal */
        e.preventDefault();
        var header = document.querySelector('header, .header, #shopify-section-header');
        var offset = header && getComputedStyle(header).position === 'fixed' ? header.offsetHeight : 0;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    }

    var bg = $('[data-cg-bg]', root);
    if (!bg || root.dataset.parallax === 'false') return;
    var reduce = matchMedia('(prefers-reduced-motion:reduce)');
    var queued = false;

    function draw() {
      queued = false;
      var top = root.getBoundingClientRect().top + window.scrollY;
      var y = Math.min(Math.max(window.scrollY - top, 0), root.offsetHeight);
      bg.style.transform = 'translate3d(0,' + (y * 0.28) + 'px,0) scale(1.06)';
    }
    function onScroll() {
      if (queued || reduce.matches) return;
      queued = true;
      requestAnimationFrame(draw);
    }
    if (!reduce.matches) {
      addEventListener('scroll', onScroll, { passive: true });
      draw();
    }
  }

  /* ======================================================================
     GRILLE — achat direct depuis la carte
     ====================================================================== */
  function initGrid(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-buy]');
      if (!b || b.disabled) return;
      e.preventDefault();               /* le bouton est dans le lien de la carte */

      var id = parseInt(b.dataset.variantId, 10);
      if (!id) return;
      var label = b.textContent;
      b.disabled = true;
      cartAdd(root, id, 1).then(function () {
        b.disabled = false;
        flash(b, b.dataset.doneLabel || 'Ajouté ✓');
        afterAdd(root, root.dataset.afterAdd);
      }).catch(function () {
        b.disabled = false;
        b.textContent = label;
        flash(b, b.dataset.errorLabel || 'Indisponible');
      });
    });
  }

  /* ======================================================================
     RANGÉE QUI DÉFILE — flèches, glisser à la souris, barre de progression
     Partagé par les avis et « les autres écussons ».
     ====================================================================== */
  function initScroller(opts) {
    var track = opts.track, prev = opts.prev, next = opts.next, bar = opts.bar;
    if (!track) return null;
    var itemSel = opts.item;

    function items() { return $$(itemSel, track).filter(function (el) { return !el.hidden; }); }

    function sync() {
      if (!items().length) return;
      var max = track.scrollWidth - track.clientWidth;
      var at = track.scrollLeft;
      /* Le rail a un padding à gauche : au repos scrollLeft vaut ce padding,
         pas 0. À droite, `max` est déjà la borne réelle. */
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      if (prev) prev.disabled = at <= pad + 2;
      if (next) next.disabled = at >= max - 2;
      if (bar) {
        var seen = track.clientWidth / track.scrollWidth;
        var fill = bar.firstElementChild;
        fill.style.width = Math.min(100, seen * 100) + '%';
        fill.style.transform = 'translateX(' + (max > 0 ? (at / max) * ((1 / seen) - 1) * 100 : 0) + '%)';
      }
    }

    function step(dir) {
      var first = items()[0];
      if (!first) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var n = Math.max(1, Math.floor(track.clientWidth / w));
      track.scrollBy({ left: dir * w * n, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    $$('img', track).forEach(function (im) {
      if (im.complete) return;
      im.addEventListener('load', sync);
      im.addEventListener('error', sync);
    });

    /* Glisser à la souris : on ne capture le pointeur qu'après 5px de vrai
       mouvement, sinon le clic simple n'atteint jamais la carte. */
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        track.setPointerCapture(drag.id);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = drag.left - dx;
    });
    function swallow(e) { e.preventDefault(); e.stopPropagation(); }
    function endDrag() {
      if (!drag) return;
      var moved = drag.moved;
      if (moved && track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
      track.classList.remove('is-dragging');
      drag = null;
      /* Après un vrai glissement, le clic de relâchement ne doit pas ouvrir la carte. */
      if (moved) track.addEventListener('click', swallow, { capture: true, once: true });
      sync();
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    sync();
    return { sync: sync, step: step };
  }

  /* ======================================================================
     IN ACTION — une vidéo à la fois
     ====================================================================== */
  function initAction(root) {
    var track = $('[data-act-track]', root);
    if (!track) return;
    var cards = $$('.cg-act__card', track).filter(function (c) { return c.querySelector('video'); });
    var soundOn = root.dataset.sound !== 'off';
    var native = root.dataset.controls === 'native';

    cards.forEach(function (c) {
      var v = c.querySelector('video');
      /* video_tag ne pose pas playsinline : sans lui iOS passe en plein écran. */
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.preload = 'metadata';
      v.removeAttribute('autoplay');
      if (native) {
        /* Barre de contrôle du navigateur : lecture, pause, volume, plein écran. */
        v.setAttribute('controls', '');
        v.controls = true;
        v.muted = !soundOn;
        if (soundOn) v.removeAttribute('muted');
        v.volume = 1;
      } else {
        v.removeAttribute('controls');
        v.muted = true;                     /* muet tant que l'utilisateur n'a pas cliqué */
      }
      v.addEventListener('pause', function () { setPlaying(c, false); });
      v.addEventListener('play', function () {
        /* Une seule vidéo à la fois, d'où qu'elle soit lancée. */
        cards.forEach(function (o) {
          if (o !== c) { var ov = o.querySelector('video'); if (!ov.paused) ov.pause(); }
        });
        setPlaying(c, true);
      });
      v.addEventListener('volumechange', function () { setMuted(c, v.muted || v.volume === 0); });
      setMuted(c, v.muted);
    });

    function setPlaying(card, on) {
      card.classList.toggle('is-playing', on);
      var b = card.querySelector('.cg-act__btn');
      if (!b) return;
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', (on ? 'Mettre en pause' : 'Lire') + ' la vidéo');
    }
    function setMuted(card, muted) {
      card.classList.toggle('is-muted', muted);
      var m = card.querySelector('.cg-act__mute');
      if (m) { m.setAttribute('aria-pressed', String(!muted)); m.setAttribute('aria-label', muted ? 'Activer le son' : 'Couper le son'); }
    }

    track.addEventListener('click', function (e) {
      var mute = e.target.closest('.cg-act__mute');
      if (mute) {
        e.preventDefault(); e.stopPropagation();
        var mc = mute.closest('.cg-act__card'), mv = mc.querySelector('video');
        mv.muted = !mv.muted;
        mv.volume = 1;
        if (!mv.muted) mv.removeAttribute('muted');
        if (!mv.muted && mv.paused) { var mp = mv.play(); if (mp && mp.catch) mp.catch(function () {}); }
        return;
      }
      var btn = e.target.closest('.cg-act__btn');
      if (!btn) return;
      var card = btn.closest('.cg-act__card');
      var v = card.querySelector('video');
      if (!v) return;

      if (v.paused) {
        /* Le clic est un geste utilisateur : le son est autorisé. */
        v.muted = !soundOn;
        v.volume = 1;
        if (soundOn) v.removeAttribute('muted');
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          /* Refus (rare) : on retente en muet. */
          v.muted = true;
          var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {});
        });
      } else {
        v.pause();
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) { var v = en.target.querySelector('video'); if (v) v.pause(); }
        });
      }, { threshold: .1 });
      cards.forEach(function (c) { io.observe(c); });
    }
    /* Onglet masqué : on coupe, sinon le son continue en arrière-plan. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cards.forEach(function (c) { c.querySelector('video').pause(); });
    });

    function step(dir) {
      var first = items()[0];
      if (!first) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var n = Math.max(1, Math.floor(track.clientWidth / w));
      track.scrollBy({ left: dir * w * n, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    $$('img', track).forEach(function (im) {
      if (im.complete) return;
      im.addEventListener('load', sync);
      im.addEventListener('error', sync);
    });

    /* Glisser à la souris : on ne capture le pointeur qu'après 5px de vrai
       mouvement, sinon le clic simple n'atteint jamais la carte. */
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        track.setPointerCapture(drag.id);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = drag.left - dx;
    });
    function swallow(e) { e.preventDefault(); e.stopPropagation(); }
    function endDrag() {
      if (!drag) return;
      var moved = drag.moved;
      if (moved && track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
      track.classList.remove('is-dragging');
      drag = null;
      /* Après un vrai glissement, le clic de relâchement ne doit pas ouvrir la carte. */
      if (moved) track.addEventListener('click', swallow, { capture: true, once: true });
      sync();
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    sync();
    return { sync: sync, step: step };
  }

  /* ======================================================================
     IN ACTION — une vidéo à la fois
     ====================================================================== */
  function initAction(root) {
    var track = $('[data-act-track]', root);
    if (!track) return;
    var cards = $$('.cg-act__card', track).filter(function (c) { return c.querySelector('video'); });

    cards.forEach(function (c) {
      var v = c.querySelector('video');
      /* video_tag ne pose pas playsinline : sans lui iOS passe en plein écran. */
      v.setAttribute('playsinline', '');
      v.muted = true;
      v.loop = true;
      v.preload = 'metadata';
      v.removeAttribute('controls');
      v.addEventListener('pause', function () { setPlaying(c, false); });
      v.addEventListener('play',  function () { setPlaying(c, true); });
    });

    function setPlaying(card, on) {
      card.classList.toggle('is-playing', on);
      var b = card.querySelector('.cg-act__btn');
      if (!b) return;
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', (on ? 'Mettre en pause' : 'Lire') + ' la vidéo');
    }

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.cg-act__btn');
      if (!btn) return;
      var card = btn.closest('.cg-act__card');
      var v = card.querySelector('video');
      if (!v) return;

      if (v.paused) {
        cards.forEach(function (c) {
          if (c !== card) { c.querySelector('video').pause(); setPlaying(c, false); }
        });
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        setPlaying(card, true);
      } else {
        v.pause();
        setPlaying(card, false);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) { var v = en.target.querySelector('video'); if (v) v.pause(); }
        });
      }, { threshold: .1 });
      cards.forEach(function (c) { io.observe(c); });
    }

    function step(dir) {
      var first = $('.cg-act__card', track);
      if (!first) return;
      track.scrollBy({ left: dir * (first.getBoundingClientRect().width + 8), behavior: 'smooth' });
    }
    var p = $('[data-act-prev]', root), n = $('[data-act-next]', root);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }

  /* ======================================================================
     FICHE PRODUIT — variantes en images, galerie par écusson, achat
     ====================================================================== */
  function initProduct(root) {
    var dataEl = $('[data-cg-variants]', root);
    if (!dataEl) return;
    var VARIANTS = [];
    try { VARIANTS = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!VARIANTS.length) return;

    var find = function (id) {
      for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].id === id) return VARIANTS[i];
      return null;
    };
    var current = find(parseInt(root.dataset.selectedId, 10)) || VARIANTS[0];
    var pattern = root.dataset.titlePattern || '';

    var galMain = $('[data-gal-main]', root), galThumbs = $('[data-gal-thumbs]', root);
    var idInput = $('input[name="id"]', root);
    var qty = $('[data-qty]', root);

    /* ---------- galerie : slider (défilement horizontal + vignettes) ---------- */
    var galFrame = galMain.parentNode;
    var galPrev = $('[data-gal-prev]', root), galNext = $('[data-gal-next]', root), galDots = $('[data-gal-dots]', root);
    var galCount = 0, galIdx = 0, galQueued = false;

    function paintGallery() {
      var media = current.media && current.media.length ? current.media : [];
      galCount = media.length;
      galIdx = 0;
      galMain.innerHTML = media.map(function (m, i) {
        return '<img src="' + m.src + '" alt="' + esc(current.title) + ' — vue ' + (i + 1) + '"'
             + ' class="' + (m.pack ? 'is-pack' : '') + '" data-i="' + i + '"'
             + ' loading="' + (i < 2 ? 'eager' : 'lazy') + '" decoding="async" draggable="false">';
      }).join('');
      galThumbs.innerHTML = media.length > 1 ? media.map(function (m, i) {
        return '<button type="button" role="tab" class="cp-thumb" data-i="' + i + '"'
             + ' aria-selected="' + (i === 0) + '" aria-label="Vue ' + (i + 1) + '">'
             + '<img src="' + m.src + '" alt="" class="' + (m.pack ? 'is-pack' : '') + '" draggable="false"></button>';
      }).join('') : '';
      if (galDots) galDots.innerHTML = media.length > 1 ? media.map(function (_, i) {
        return '<i' + (i === 0 ? ' class="is-on"' : '') + '></i>';
      }).join('') : '';
      if (galFrame) galFrame.classList.toggle('is-single', media.length < 2);
      galMain.scrollTo({ left: 0, behavior: 'auto' });
      syncGallery(0);
    }
    function syncGallery(i) {
      galIdx = i;
      $$('.cp-thumb', galThumbs).forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-selected', String(on));
        if (on && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      if (galDots) $$('i', galDots).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (galPrev) galPrev.disabled = i <= 0;
      if (galNext) galNext.disabled = i >= galCount - 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(i, galCount - 1));
      galMain.scrollTo({ left: i * galMain.clientWidth, behavior: 'smooth' });
      syncGallery(i);
    }
    galMain.addEventListener('scroll', function () {
      if (galQueued) return;
      galQueued = true;
      requestAnimationFrame(function () {
        galQueued = false;
        var w = galMain.clientWidth || 1;
        var i = Math.round(galMain.scrollLeft / w);
        if (i !== galIdx) syncGallery(i);
      });
    }, { passive: true });
    galThumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.cp-thumb');
      if (t) goTo(+t.dataset.i);
    });
    if (galPrev) galPrev.addEventListener('click', function () { goTo(galIdx - 1); });
    if (galNext) galNext.addEventListener('click', function () { goTo(galIdx + 1); });
    galMain.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(galIdx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(galIdx + 1); }
    });
    addEventListener('resize', function () {
      galMain.scrollTo({ left: galIdx * galMain.clientWidth, behavior: 'auto' });
    });

    /* ---------- texte / prix ---------- */
    function paintText() {
      $$('[data-vname]', root).forEach(function (el) { el.textContent = current.title; });
      if (pattern) {
        var t = pattern.replace('[variant]', current.title);
        $$('[data-title]', root).forEach(function (el) { el.textContent = t; });
        document.title = t + ' — ' + (root.dataset.shopName || '');
      }
      $$('[data-now]', root).forEach(function (el) { el.innerHTML = current.price; });
      $$('[data-was]', root).forEach(function (el) { el.innerHTML = current.compare || ''; el.hidden = !current.compare; });
      $$('[data-save]', root).forEach(function (el) { el.textContent = '-' + current.save + '%'; el.hidden = !current.save; });
      $$('[data-add],[data-buy]', root).forEach(function (b) {
        b.disabled = !current.available;
        if (!current.available) b.textContent = b.dataset.soldoutLabel || 'Épuisé';
        else if (b.dataset.label) b.textContent = b.dataset.label;
      });
    }

    /* ---------- variante ---------- */
    function setVariant(id, push) {
      var v = find(id);
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      $$('.cp-var', root).forEach(function (b) {
        b.setAttribute('aria-checked', String(parseInt(b.dataset.variantId, 10) === v.id));
      });
      paintGallery();
      paintText();
      if (push !== false && v.url) history.replaceState(null, '', v.url);
      document.dispatchEvent(new CustomEvent('cagoule:variant', { detail: { id: v.id } }));
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.cp-var');
      if (b) setVariant(parseInt(b.dataset.variantId, 10));
    });
    /* La section « autres écussons » demande un changement sans recharger. */
    document.addEventListener('cagoule:goto', function (e) {
      setVariant(e.detail.id);
      scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
    });

    /* ---------- quantité ---------- */
    function readQty() {
      if (!qty) return 1;
      var n = parseInt(qty.value, 10);
      return (!n || n < 1) ? 1 : Math.min(n, 99);
    }
    $$('[data-q]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, readQty() + (b.dataset.q === '+' ? 1 : -1));
      });
    });
    if (qty) qty.addEventListener('blur', function () { qty.value = readQty(); });

    /* ---------- achat ---------- */
    function add(btn, mode) {
      if (!current.available) return;
      if (btn) btn.disabled = true;
      cartAdd(root, current.id, readQty()).then(function () {
        if (btn) { btn.disabled = false; flash(btn, btn.dataset.doneLabel || 'Ajouté ✓'); }
        afterAdd(root, mode);
      }).catch(function () {
        if (btn) { btn.disabled = false; flash(btn, btn.dataset.errorLabel || 'Erreur'); }
      });
    }
    $$('[data-add]', root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); add(b, root.dataset.afterAdd); });
    });
    $$('[data-buy]', root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); add(b, root.dataset.buyAction || 'checkout'); });
    });
    /* Le formulaire reste soumissible sans script (fallback natif Shopify). */
    var form = $('form[data-cg-form]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add($('[data-add]', root), root.dataset.afterAdd); });

    /* Barre d'achat mobile : le body reçoit le padding qui la dégage. */
    if ($('.cp-bar', root)) document.body.classList.add('cg-has-bar');

    initAccordions(root);
    paintGallery();
    paintText();
    document.dispatchEvent(new CustomEvent('cagoule:variant', { detail: { id: current.id } }));
  }

  /* ======================================================================
     MERCI — numéro de commande depuis l'URL (?order=1001&total=199)
     ====================================================================== */
  function initThankyou(root) {
    /* ---------- produits : rangée qui défile (swipe + flèches) ---------- */
    var track = $('[data-ty-track]', root);
    if (track) {
      var prev = $('[data-ty-prev]', root), next = $('[data-ty-next]', root);
      var step = function () {
        var c = track.firstElementChild;
        return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) : track.clientWidth;
      };
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync);
      sync();
    }

    /* ---------- numéro de commande depuis l'URL ---------- */
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var num = q.get('order') || q.get('order_number') || q.get('order_id') || q.get('name') || '';
    var total = q.get('total') || q.get('amount') || '';
    num = String(num).replace(/[^0-9A-Za-z#-]/g, '').slice(0, 24);
    total = String(total).replace(/[^0-9.,\s]/g, '').slice(0, 16);
    if (!num) return;
    if (num.charAt(0) !== '#') num = '#' + num;

    var box = $('[data-ty-order]', root), n = $('[data-ty-number]', root), t = $('[data-ty-total]', root);
    if (n) n.textContent = num;
    if (t && total) { t.textContent = total + ' dh'; t.hidden = false; }
    if (box) box.hidden = false;

    /* Le message WhatsApp reprend le numéro : plus simple pour le client. */
    var wa = $('[data-ty-wa]', root);
    if (wa && root.dataset.wa) {
      var txt = (root.dataset.waText || '') + ' ' + num;
      wa.href = 'https://wa.me/' + root.dataset.wa + '?text=' + encodeURIComponent(txt.trim());
    }
  }

  /* ======================================================================
     ACCORDÉONS — détails produit et FAQ
     ====================================================================== */
  function initAccordions(root) {
    $$('.cp-acc__q, .cp-faq__q', root).forEach(function (q) {
      if (q.dataset.cgBound) return;
      q.dataset.cgBound = '1';
      q.addEventListener('click', function () {
        var open = q.parentElement.classList.toggle('is-open');
        q.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ======================================================================
     EN-TÊTE — menu mobile
     ====================================================================== */
  function initHeader(root) {
    var btn = $('[data-hd-toggle]', root);
    var nav = $('[data-hd-nav]', root);
    var scrim = $('[data-hd-scrim]', root.parentElement || document);
    if (!btn || !nav) return;

    function set(open) {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (scrim) scrim.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }
    btn.addEventListener('click', function () {
      set(btn.getAttribute('aria-expanded') !== 'true');
    });
    if (scrim) scrim.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') set(false);
    });
    /* Repasser en desktop doit fermer le menu, sinon il reste ouvert. */
    matchMedia('(min-width:1081px)').addEventListener('change', function (e) {
      if (e.matches) set(false);
    });
  }

  /* ======================================================================
     GRILLE PRODUITS — achat depuis la carte
     ====================================================================== */
  function initCollectionGrid(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-buy]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var id = parseInt(b.dataset.variantId, 10);
      if (!id) return;
      var label = b.textContent;
      b.disabled = true;
      cartAdd(root, id, 1).then(function () {
        b.disabled = false;
        flash(b, b.dataset.doneLabel || 'Ajouté ✓');
        afterAdd(root, root.dataset.afterAdd);
      }).catch(function () {
        b.disabled = false;
        b.textContent = label;
        flash(b, b.dataset.errorLabel || 'Indisponible');
      });
    });
  }

  /* ======================================================================
     SUIVI DE COMMANDE — le formulaire emmène le client là où l'info existe
     ====================================================================== */
  function initTracking(root) {
    var form = $('[data-tk-form]', root);
    if (!form) return;
    var fName = $('[data-tk-name]', root), fPhone = $('[data-tk-phone]', root), fDet = $('[data-tk-details]', root);
    var err = $('[data-tk-err]', root);
    var fields = [fName, fPhone, fDet].filter(Boolean);

    fields.forEach(function (f) {
      f.addEventListener('input', function () { f.classList.remove('is-bad'); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = null;
      fields.forEach(function (f) {
        var ok = (f.value || '').trim().length > 0;
        if (f === fPhone && ok) ok = (f.value.replace(/[^0-9]/g, '').length >= 9);
        f.classList.toggle('is-bad', !ok);
        if (!ok && !bad) bad = f;
      });
      if (bad) {
        if (err) err.hidden = false;
        bad.focus();
        return;
      }
      if (err) err.hidden = true;

      var wa = (root.dataset.wa || '').replace(/[^0-9]/g, '');
      if (!wa) return;
      var lines = [
        root.dataset.waText || 'Bonjour, je souhaite suivre ma commande.',
        '',
        (root.dataset.labelName || 'Nom') + ' : ' + fName.value.trim(),
        (root.dataset.labelPhone || 'Téléphone') + ' : ' + fPhone.value.trim(),
        (root.dataset.labelDetails || 'Commande') + ' : ' + fDet.value.trim()
      ];
      window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
    });

    /* Les questions de cette page réutilisent les accordéons. */
    initAccordions(root);
  }

  /* ======================================================================
     AVIS — captures qui défilent + visionneuse
     ====================================================================== */
  function initReviews(root) {
    var shots = $('[data-rev-track]', root);
    if (!shots) return;
    var cards = $$('.cp-rev__shot', shots);
    var filled = function () { return cards.filter(function (c) { return !c.classList.contains('is-empty'); }); };

    initScroller({
      track: shots,
      item: '.cp-rev__shot',
      prev: $('[data-rev-prev]', root),
      next: $('[data-rev-next]', root),
      bar: $('[data-rev-bar]', root)
    });

    /* ---------- visionneuse ---------- */
    var lb = $('[data-lb]', root), lbImg = $('[data-lb-img]', root), lbCount = $('[data-lb-count]', root), lbAt = 0;
    if (!lb) return;

    function lbShow(i) {
      var list = filled();
      if (!list.length) return;
      lbAt = (i + list.length) % list.length;
      var img = list[lbAt].querySelector('img');
      lbImg.src = img.dataset.full || img.currentSrc || img.src;
      lbImg.alt = img.alt || ('Avis client ' + (lbAt + 1));
      lbCount.textContent = (lbAt + 1) + ' / ' + list.length;
      lb.classList.add('is-on');
    }
    function lbClose() { lb.classList.remove('is-on'); }
    function lbOpenFrom(c) {
      if (!c || c.classList.contains('is-empty')) return;
      lbShow(filled().indexOf(c));
    }
    shots.addEventListener('click', function (e) { lbOpenFrom(e.target.closest('.cp-rev__shot')); });
    shots.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var c = e.target.closest('.cp-rev__shot');
      if (!c) return;
      e.preventDefault();
      lbOpenFrom(c);
    });
    $('[data-lb-close]', root).addEventListener('click', lbClose);
    $('[data-lb-prev]', root).addEventListener('click', function () { lbShow(lbAt - 1); });
    $('[data-lb-next]', root).addEventListener('click', function () { lbShow(lbAt + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-on')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(lbAt - 1);
      if (e.key === 'ArrowRight') lbShow(lbAt + 1);
    });
  }

  /* ======================================================================
     AUTRES ÉCUSSONS — masque l'écusson affiché, change sans recharger
     ====================================================================== */
  function initAlso(root) {
    /* Source « Recommandations » : Shopify ne les rend pas au premier
       chargement, il faut les demander à product_recommendations_url. */
    var reco = root.dataset.recoUrl;
    if (reco && !$('.cl-card', root) && !$('[data-variant-id]', root)) {
      fetch(reco)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-also-track]');
          var here = $('[data-also-track]', root);
          if (fresh && here && fresh.innerHTML.trim()) {
            here.innerHTML = fresh.innerHTML;
            root.dataset.cgInit = '';
            initAll(root);
          }
        })
        .catch(function () {});
      return;
    }

    var cards = $$('[data-variant-id]', root);
    var hasMain = !!$('[data-cg-section="cagoule-main"]');

    /* Achat direct depuis une carte produit de la rangée. */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-buy]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var id = parseInt(b.dataset.variantId, 10);
      if (!id) return;
      var label = b.textContent;
      b.disabled = true;
      cartAdd(root, id, 1).then(function () {
        b.disabled = false;
        flash(b, b.dataset.doneLabel || 'Ajouté ✓');
        afterAdd(root, root.dataset.afterAdd);
      }).catch(function () {
        b.disabled = false;
        b.textContent = label;
        flash(b, b.dataset.errorLabel || 'Indisponible');
      });
    });

    var sc = initScroller({
      track: $('[data-also-track]', root),
      item: '.cl-card, [data-variant-id]',
      prev: $('[data-also-prev]', root),
      next: $('[data-also-next]', root),
      bar: $('[data-also-bar]', root)
    });

    document.addEventListener('cagoule:variant', function (e) {
      cards.forEach(function (c) { c.hidden = parseInt(c.dataset.variantId, 10) === e.detail.id; });
      /* Une carte masquée change la largeur utile : les flèches doivent suivre. */
      if (sc) sc.sync();
    });
    if (hasMain) {
      root.addEventListener('click', function (e) {
        var a = e.target.closest('[data-variant-id]');
        if (!a) return;
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cagoule:goto', { detail: { id: parseInt(a.dataset.variantId, 10) } }));
      });
    }
  }

  /* ======================================================================
     Boot
     ====================================================================== */
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var INIT = {
    'custom-header':      initHeader,
    'custom-footer':      function () {},
    'collection-grid':    initCollectionGrid,
    'page-tracking':      initTracking,
    'page-thankyou':      initThankyou,
    'page-contact':       function () {},
    'page-about':         function () {},
    'cagoules-hero':      initHero,
    'cagoules-grid':      initGrid,
    'cagoules-action':    initAction,
    'cagoule-main':       initProduct,
    'cagoule-reviews':    initReviews,
    'cagoule-faq':        initAccordions,
    'cagoule-also':       initAlso
  };

  function initAll(scope) {
    $$('[data-cg-section]', scope && scope.querySelectorAll ? scope : document).forEach(function (el) {
      if (el.dataset.cgInit) return;
      el.dataset.cgInit = '1';
      var f = INIT[el.dataset.cgSection];
      if (f) f(el);
    });
    /* Si `scope` est lui-même une section (éditeur de thème). */
    if (scope && scope.dataset && scope.dataset.cgSection && !scope.dataset.cgInit) {
      scope.dataset.cgInit = '1';
      var g = INIT[scope.dataset.cgSection];
      if (g) g(scope);
    }
  }

  window.CagoulesInit = initAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
